module.exports = __webpack_public_path__ + "img/64.58d6c5d9.jpg";